import isDefined from '@automator/utilities/is-defined';

/**
 * Animates the height of the matched element to slide down, revealing the content.
 *
 * @param {Node} $element - The element to animate.
 * @param {Object} options - The options for the animation.
 * @param {Number} [options.duration] - The duration of the animation in milliseconds.
 * @param {Function} [options.onComplete] - The callback function to invoke when the animation is completed.
 * @return {undefined}
 */
const slideDown = ( $element, { duration, onComplete } ) => {
	// Check if there is a custom duration defined
	if ( isDefined( duration ) ) {
		$element.style.transitionDuration = `${duration}ms`;
	}

	// Display the element
	$element.style.removeProperty( 'display' );

	// Set the height to auto to get the real height
	$element.style.height = 'auto';

	// Get the height
	const height = `${$element.clientHeight}px`;

	// Set the height to 0 to prepare the element for the transition
	$element.style.height = '0px';

	setTimeout( () => {
		// Set the real height
		$element.style.height = height;

		// Check if there is a callback defined
		$element.addEventListener(
			'transitionend',
			() => {
				// Remove the height property
				$element.style.removeProperty( 'height' );

				// Check if there is a custom duration defined
				if ( isDefined( duration ) ) {
					$element.style.removeProperty( 'transition-duration' );
				}

				// Check if there is a callback defined
				if ( isDefined( onComplete ) ) {
					try {
						onComplete();
					} catch ( e ) {}
				}
			},
			{
				// Invoke only once
				once: true,
			}
		);
	}, 0 );
};

export default slideDown;
